module.exports = __webpack_public_path__ + "img/img-hero-mobile@2x.d46788b1.jpg";